<div class="modal-header">
  <h2>{{'restaurant.selectModal.title' | translate}}</h2>
  <!--  <a class="mdlb-cart-remove" href="javascript: void(0)" (click)="bsModalRef.hide()">&times;</a>-->
</div>
<div class="modal-body">
  <img src="assets/images/restaurants_map.jpg" alt="restaurants_map" />

  <div class="d-flex flex-md-row flex-wrap flex-column justify-content-center">
    <button type="button" (click)="restaurantSelected(restaurant)" class="btn btn-primary mt-3 mx-md-2" *ngFor="let restaurant of restaurants">
      {{restaurant.name}}
    </button>
  </div>
</div>
